import {ssrSafeDocument, ssrSafeWindow} from '@github-ui/ssr-utils'

// Concurrent queries share two listeners; each measurement only snapshots these generations.
let hiddenGeneration = 0
let offlineGeneration = 0

ssrSafeDocument?.addEventListener('visibilitychange', () => {
  if (ssrSafeDocument?.visibilityState === 'hidden') hiddenGeneration++
})
ssrSafeWindow?.addEventListener('offline', () => offlineGeneration++)

export function startQueryLifecycleMeasurement() {
  const startedHidden = ssrSafeDocument?.visibilityState === 'hidden'
  const startedOffline = ssrSafeWindow?.navigator.onLine === false
  const initialHiddenGeneration = hiddenGeneration
  const initialOfflineGeneration = offlineGeneration

  return {
    tags() {
      return {
        pageHidden: String(startedHidden || hiddenGeneration !== initialHiddenGeneration),
        wentOffline: String(startedOffline || offlineGeneration !== initialOfflineGeneration),
      }
    },
  }
}
